module.exports = __webpack_public_path__ + "static/media/opening_04.b1612484.webp";